/**
 * Remote Log Target (Stub)
 * 
 * Placeholder for future remote logging endpoint.
 * Will send logs to a remote server for aggregation/analysis.
 */

import type { LogEntry, LogTarget } from '../types.js';

/**
 * Remote log target (stub for future implementation)
 */
export class RemoteTarget implements LogTarget {
  // @ts-ignore - endpoint will be used when remote logging is implemented
  private readonly endpoint: string;
  private buffer: LogEntry[] = [];
  private _flushInterval: ReturnType<typeof setInterval> | null = null;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
    // Flush buffer periodically (every 5 seconds)
    this._flushInterval = setInterval(() => this.flush(), 5000);
  }

  write(entry: LogEntry): void {
    this.buffer.push(entry);

    // Flush immediately for errors
    if (entry.level === 'error') {
      this.flush();
    }
  }

  /**
   * Flush buffered logs to remote endpoint
   */
  private async flush(): Promise<void> {
    if (this.buffer.length === 0) return;

    const logs = [...this.buffer];
    this.buffer = [];

    try {
      // TODO: Implement actual remote logging when endpoint is needed
      // await fetch(this.endpoint, {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ logs }),
      // });

      // For now, just log to console
    } catch (error) {
      // Re-add logs to buffer on failure
      this.buffer.unshift(...logs);
    }
  }

  clear(): void {
    this.buffer = [];
  }

  /**
   * Cleanup interval on destroy
   */
  destroy(): void {
    if (this._flushInterval) {
      clearInterval(this._flushInterval);
      this._flushInterval = null;
    }
  }
}

